<!-- <style>
  .mat-tab-body-content {
    overflow: hidden !important;
  }
</style> -->
<div class="row">
  <div class="col-md-9">
    <!-- <mat-form-field>
     <mat-label>Provider Name</mat-label> 

      <select
        matNativeControl
        [(ngModel)]="selected"
        (change)="onChageProvider($event)"
      >
        <option>All</option> 
        <option *ngFor="let tduList of tduArr" [value]="tduList.value">
          {{ tduList.text }}
        </option>
      </select>
    </mat-form-field> -->
    <!-- <mat-form-field>
        <mat-select (selectionChange)="onChageProvider($event)">
          <mat-option value="Gexa Energy">Gexa Energy</mat-option>
          <mat-option value="4Change Energy">4Change Energy</mat-option>
          <mat-option value="Chariot Energy">Chariot Energy</mat-option>
          <mat-option value="Pulse Power">Pulse Power</mat-option>
          <mat-option value="New Power Texas">New Power Texas</mat-option>
          <mat-option value="Bulb">bulb</mat-option>
          <mat-option value="Pronto Power">Pronto Power</mat-option>
          <mat-option value="Texpo Energy">Texpo Energy</mat-option>
          <mat-option value="Texpo Energy">Texpo Energy</mat-option>
        </mat-select>
      </mat-form-field> -->
  </div>
  <div class="col-md-3">
    <button mat-raised-button (click)="createTDURatesDialog('Add')">
      Create
    </button>
  </div>
</div>
<div class="table-responsive">
  <table mat-table [dataSource]="tduData">
    <!-- Position Column -->
    <ng-container matColumnDef="action">
      <tr>
        <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">Action</th>
      </tr>
      <tr>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="'w-130'"
          style="width: 5%"
        >
          <button
            mat-icon-button
            color="primary"
            title="Edit Contact"
            (click)="createTDURatesDialog('Update', element)"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </tr>

      <tr></tr
    ></ng-container>
    <ng-container matColumnDef="Abbreviation">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        Abbreviation
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Abbreviation }}
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="Code">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">Code</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Code }}
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="IstaId">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">IstaId</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.IstaId }}
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="MoveInFee">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">MoveInFee</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        ${{ checkForWholeOrDecimal(element.MoveInFee) }}
      </td>
    </ng-container>
    <!-- <ng-container matColumnDef="PUCT">
        <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'"> PUCT </th>
        <td mat-cell *matCellDef="let element" [ngClass]="'w-130'"> {{element.PUCT}} </td>
      </ng-container>  -->
    <ng-container matColumnDef="PriorityMoveInFee">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        PriorityMoveInFee
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        <!-- {{ element.PriorityMoveInFee }} -->
        ${{ checkForWholeOrDecimal(element.PriorityMoveInFee) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="SwitchFee">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">SwitchFee</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        ${{ checkForWholeOrDecimal(element.SwitchFee) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="TypeOfTDU">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">UtilityName</th>
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">TypeOfTDU</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.TypeOfTDU }}
      </td>
    </ng-container>
    <ng-container matColumnDef="TDU_Charges_Month">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        TDU_Charges_Month
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.TDU_Charges_Month }}
      </td>
    </ng-container>
    <ng-container matColumnDef="TDU_Charges_Kwh">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        TDU_Charges_Kwh
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.TDU_Charges_Kwh }}
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="Daily_Charge">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        Daily Charge
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Daily_Charge }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Energy_Price">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        Energy Price
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Energy_Price }}
      </td>
    </ng-container> -->
    <!-- <ng-container matColumnDef="Five_Hundred">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">500</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Five_Hundred }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Thousand">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">1000</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Thousand }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Two_Thousand">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">2000</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Two_Thousand }}
      </td>
    </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="tduDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tduDisplayedColumns"></tr>
  </table>
</div>
<mat-paginator
  #tduPaginator="matPaginator"
  [pageSizeOptions]="[5, 10, 20]"
  showFirstLastButtons
  aria-label="Select page of periodic elements"
>
</mat-paginator>
